export const allCategories = [{
  id: 'all',
  name: 'any'
}, {
  id: '1065976',
  name: 'wallpapers'
}, {
  id: '3330445',
  name: 'textures-patterns'
}, {
  id: '3330448',
  name: 'nature'
}, {
  id: '3356631',
  name: 'current-events'
}, {
  id: '3348849',
  name: 'architecture'
}, {
  id: '3348877',
  name: 'business-work'
}, {
  id: '3330452',
  name: 'animals'
}, {
  id: '3356570',
  name: 'travel'
}, {
  id: '3356576',
  name: 'fashion'
}, {
  id: '3330455',
  name: 'food-drink'
}, {
  id: '3356581',
  name: 'spirituality'
}, {
  id: '3356584',
  name: 'experimental'
}, {
  id: '3356568',
  name: 'people'
}, {
  id: '3356594',
  name: 'health'
}, {
  id: '3330461',
  name: 'arts-culture'
}];